import antdIt from "antd/lib/locale-provider/it_IT";
import appLocaleData from "react-intl/locale-data/it";
import enMessages from "../locales/en_US.json";
import itMessages from "../locales/it_IT.json";

const ItLang = {
  messages: {
    ...enMessages,
    ...itMessages
  },
  antd: antdIt,
  locale: 'it',
  data: appLocaleData
};
export default ItLang;
